import { setDate as setDateFns } from 'date-fns';

export default function setDate(date: Date, year: number): Date {
  return setDateFns(date, year);
}
